"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BehanceSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function BehanceSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Behance"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "behance-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,92.5H18.571A11.084,11.084,0,0,1,7.5,81.429V18.571A11.084,11.084,0,0,1,18.571,7.5H81.429A11.084,11.084,0,0,1,92.5,18.571V81.429A11.084,11.084,0,0,1,81.429,92.5Zm-62.858-80A6.079,6.079,0,0,0,12.5,18.571V81.429A6.079,6.079,0,0,0,18.571,87.5H81.429A6.079,6.079,0,0,0,87.5,81.429V18.571A6.079,6.079,0,0,0,81.429,12.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M45.917,48.633a5.536,5.536,0,0,0,3.529-5.4c0-5.148-3.836-6.4-8.262-6.4H29V62.677H41.527c4.7,0,9.107-2.254,9.107-7.5,0-3.244-1.538-5.643-4.717-6.54ZM34.68,41.246h5.33c2.049,0,3.894.576,3.894,2.953,0,2.2-1.436,3.078-3.463,3.078H34.68Zm6.074,17.041H34.68V51.17h6.191c2.5,0,4.083,1.043,4.083,3.69,0,2.61-1.888,3.427-4.2,3.427ZM66.9,40.736H56.417V38.191H66.9v2.545ZM71,53.591c0-5.534-3.238-10.15-9.107-10.15-5.7,0-9.574,4.288-9.574,9.9,0,5.826,3.667,9.822,9.574,9.822,4.469,0,7.364-2.012,8.757-6.293H66.115c-.489,1.6-2.5,2.443-4.062,2.443-3.011,0-4.594-1.764-4.594-4.761h13.5C70.978,54.247,71,53.919,71,53.591ZM57.467,51.316a4.016,4.016,0,0,1,4.265-4c2.582,0,3.879,1.517,4.1,4Z"
  })))));
}